<template>
  <main class="dashboard">
    <v-container>
      <h1 class="d-flex justify-space-between w-100 mt-12">
        <span>Applicants List</span>
      </h1>
      <v-row>
        <v-col cols="12">
          <v-alert
            v-if="globalServerErrors !== null"
            dense
            outlined
            type="error"
          >
            <p
              class="mb-0"
              v-for="globalErr in globalServerErrors"
              :key="globalErr"
            >
              {{ globalErr[0] }}
            </p>
          </v-alert>
        </v-col>
        <v-col cols="12" sm="3" class="py-0">
          <v-autocomplete
            :items="appTypes"
            item-text="name"
            item-value="id"
            label="App Type"
            dense
            filled
            :append-icon="form.type ? 'mdi-close' : ''"
            @click:append="clearSearchData('type')"
            v-model="form.type"
            @change="filterTypes"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" class="py-0">
          <v-autocomplete
            :items="phases"
            item-text="name"
            item-value="id"
            label="Phases"
            dense
            filled
            :append-icon="form.phase ? 'mdi-close' : ''"
            :disabled="!form.type"
            @click:append="clearSearchData('phase')"
            v-model="form.phase"
            @change="filterPhases"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" class="py-0">
          <v-autocomplete
            :items="questions"
            item-text="body"
            item-value="id"
            label="Questions"
            dense
            filled
            return-object
            :append-icon="form.phase ? 'mdi-close' : ''"
            :disabled="!form.phase"
            @click:append="clearSearchData('question')"
            v-model="form.question"
            @change="filterQuestions"
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title
                  v-html="data.item ? data.item.body : ''"
                ></v-list-item-title>
                <!-- <v-list-item-subtitle
                  v-html="data.item.group"
                ></v-list-item-subtitle> -->
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" class="py-0">
          <v-text-field
            v-if="choices.length == 0"
            regular
            dense
            filled
            label="Answer"
            :disabled="!form.question"
            v-model.trim="form.answer"
            type="text"
          >
          </v-text-field>
          <v-autocomplete
            v-else
            :items="choices"
            item-text="value"
            item-value="id"
            label="Choices"
            dense
            filled
            return-object
            :append-icon="form.choice ? 'mdi-close' : ''"
            :disabled="!form.question"
            @click:append="clearSearchData('choice')"
            v-model="form.choice"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" class="py-0">
          <v-btn
            :disabled="!form.answer && !form.choice"
            color="primary"
            class="mb-5"
            @click="search"
            >Search</v-btn
          >
          <v-btn
            :disabled="!form.answer && !form.choice"
            color="error"
            class="mb-5 mx-3"
            @click="reset"
            >Clear</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="apps.length > 0">
        <v-col cols="12" sm="6" md="4" v-for="app in apps" :key="app.index">
          <v-card
            class="radius-12 px-2 pt-3 pb-10 global-card global-card__except dashboard__card"
          >
            <router-link
              :to="{
                name: 'dashboardApplicant',
                params: { id: app.id }
              }"
            >
              <div class="d-flex flex-no-wrap justify-space-between">
                <v-avatar class="ma-3" size="70" tile>
                  <v-img
                    :src="app.applicant ? app.applicant.photo : ''"
                  ></v-img>
                </v-avatar>
                <section>
                  <h5 class="color-black">
                    {{ app.applicant.full_name || "---" }}
                  </h5>

                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{
                      app.applicant.email || "---"
                    }}</small></v-card-subtitle
                  >
                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{
                      app.applicant.mobile || "---"
                    }}</small></v-card-subtitle
                  >
                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{
                      app.applicant.type.name || "---"
                    }}</small></v-card-subtitle
                  >
                  <v-card-subtitle v-if="app.applicant.about" class="pa-0 l-h-1"
                    ><small>{{ app.applicant.about }}</small></v-card-subtitle
                  >
                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{ app.serial }}</small></v-card-subtitle
                  >
                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{
                      app.signed_at ? app.signed_at.date : ""
                    }}</small></v-card-subtitle
                  >
                  <v-chip
                    class="mt-3 dashboard__card-status"
                    :class="app.status.name || 'default'"
                    small
                    >{{ app.status.name || "---" }}</v-chip
                  >
                </section>
              </div>
            </router-link>
          </v-card>
        </v-col>
      </v-row>
      <p v-else>No Applicant Found</p>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="apps.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
  </main>
</template>

<script>
import { IndexData, StoreData } from "@/helpers/apiMethods";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      apps: [],
      appTypes: [],
      questions: [],
      phases: [],
      choices: [],
      filter: {
        statuses: "",
        type: "",
        from: "",
        to: "",
        religions: ""
      },
      form: {},
      menu1: false,
      menu2: false,
      statistics: {},
      pagination: {},
      queries: {},
      questionId: "",
      globalServerErrors: null
    };
  },
  components: {
    // InputFilter: () => import("@/views/accounts/components/InputFilter")
  },
  created() {
    this.indexStatuses();
    this.indexStatistics();
    this.indexAppTypes();
  },
  methods: {
    indexApps(query) {
      IndexData({ reqName: `hr/dashboard/applications`, query })
        .then(res => {
          const { data, meta } = res.data;
          this.apps = data;
          this.pagination = meta;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexStatistics() {
      IndexData({ reqName: `hr/dashboard/statistics` })
        .then(res => {
          // const { data } = res.data;
          this.statistics = res.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexStatuses() {
      IndexData({ reqName: `hr/dashboard/application-statuses` })
        .then(res => {
          this.statuses = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexAppTypes() {
      IndexData({ reqName: `hr/dashboard/application-types` })
        .then(res => {
          this.appTypes = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },

    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    filterStatus(statuses) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({
        query: { ...routeQuery, statuses, page: 1 }
      });
    },
    filterTypes(type) {
      IndexData({ reqName: `hr/dashboard/application-types/${type}/phases` })
        .then(res => {
          this.phases = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    filterPhases(phase) {
      IndexData({ reqName: `hr/dashboard/phases/${phase}/questions` })
        .then(res => {
          this.questions = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    filterQuestions(item) {
      this.questionId = item.id;
      this.choices = item.choices;
      console.log(item);
    },
    search() {
      const formData = new FormData();

      Object.keys(this.form).forEach(formItem => {
        if (formItem === "question") {
          formData.append("answers[0][question]", this.form[formItem].id);
        } else if (formItem === "answer") {
          formData.append("answers[0][value]", this.form[formItem]);
        } else if (formItem === "choice") {
          formData.append("answers[0][value]", this.form[formItem].id);
        }
      });
      StoreData({
        reqName: `hr/dashboard/search`,
        data: formData
      })
        .then(res => {
          this.apps = res.data.applications;
          this.globalServerErrors = null;
          if (res.data.applications.length > 0) {
            window.location.href = res.data.url;
          }
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
        })
        .finally(() => {
          // this.reset();
        });
    },
    clearSearchData(name) {
      let routeQuery = { ...this.$route.query };
      this.form[name] = "";
      delete routeQuery[name];
      this.$router.push({ query: routeQuery });
    },
    reset() {
      this.form.type = "";
      this.form.phase = "";
      this.form.question = "";
      this.form.answer = "";
      if (this.choices.length > 0) {
        this.form.choice = null;
      }
      this.globalServerErrors = null;
    }
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        this.queries = query;
        this.pagination.current_page = query.page;
        this.indexApps(query);
      },
      immediate: true
    }
  }
};
</script>
